import React, { useContext, useState } from "react";
import { Banner, Button, Link, Select, Stack } from "@shopify/polaris";
import { PrivateContext } from "lib/context";

import constant from "lib/constant/constant";
import { withErrorBoundary } from "lib/hoc";

const Add = (props) => {
  const { cms } = useContext(PrivateContext);
  const { isSelectedVendor, setVendors, setSubmitEnable, vendorList, vendors } = props;
  const [banner, setBanner] = useState({
    isOpen: false,
    status: "",
    title: "",
    onDismiss: null,
  });
  const addItem = () => {
    const vendorItem = [...vendors];
    if (vendorItem.length > 0) {
      const item = vendorItem[vendorItem.length - 1];
      const keys = Object.keys(item);
      let isInvalid = false;
      keys.forEach((key) => {
        if (!item[key]) {
          isInvalid = true;
        }
      });

      if (isInvalid) {
        setBanner({
          isOpen: true,
          title: cms("common.message.error.invalidRowDetails"),
          status: constant.CRITICAL,
        });
      } else
        vendorItem.push({
          vendorId: "",
        });
      setVendors(vendorItem);
      setSubmitEnable(true);
    }
    if (!vendorItem.length) {
      setVendors([{ vendorId: "" }]);
    }
  };

  const removeItem = (id) => {
    const vendorItem = [...vendors];
    vendorItem.splice(id, 1);
    setVendors(vendorItem);
    setSubmitEnable(true);
  };

  const handleChange = (field, value, index) => {
    setBanner({ isOpen: false, title: "", status: "" });
    const vendorItem = [...vendors];
    vendorItem[index][field] = value;
    setVendors([...vendorItem]);
    setSubmitEnable(true);
  };
  const selectVendor = (data, id) => {
    return (
      <>
        <Stack>
          <Stack.Item>
            <div className="formWidth125px">
              <Select
                options={vendorList}
                placeholder={cms("section.access.placeholder.vendor")}
                value={vendors && vendors.length && vendors[id].vendorId}
                onChange={(value) => handleChange(constant.VENDOR_ID, value, id)}
              />
            </div>
          </Stack.Item>
          <Stack.Item>
            <Button size="plain" onClick={() => removeItem(id)}>
              <i className="far fa-trash fa-lg" style={{ color: constant.color.RED }} />
            </Button>
          </Stack.Item>
        </Stack>
        <br />
      </>
    );
  };

  return (
    <div>
      {banner.isOpen && (
        <>
          <Banner
            isOpen={banner.isOpen}
            status={banner.status}
            title={banner.title}
            onDismiss={() => setBanner({ isOpen: false, title: "", status: "" })}
          />
          <br />
        </>
      )}
      {isSelectedVendor &&
        vendors &&
        vendors.map((value, index) => {
          return selectVendor(value, index);
        })}
      {isSelectedVendor && (
        <Link id="addLink" onClick={() => addItem()}>
          {constant.SUM_SYMBOL}
          {cms("section.access.button.vendor")}
        </Link>
      )}
    </div>
  );
};

export default withErrorBoundary(Add);
